import { mainApiAxios as axios } from '@/plugins/axios'


export default {

    listElibraryCategories() {
        return axios.get('elibraryCategories')
    },
    getElibraryCategory(categoryId) {
        return axios.get(`elibraryCategories/${categoryId}`)
    },
    updateElibraryCategory(categoryId, elibraryCategoryObj) {
        return axios.post(`elibraryCategories/update/${categoryId}`, elibraryCategoryObj)
    },

    addElibraryCategory(elibraryCategoryObj) {
        return axios.post('elibraryCategories', elibraryCategoryObj)
    },

    deleteElibraryCategory(categoryId) {
        return axios.post(`elibraryCategories/delete/${categoryId}`)
    },
}